jQuery(function(){
    function getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

          // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return "unknown";
    }

    function iOSversion() {
      if (/iP(hone|od|ad)/.test(navigator.platform)) {
        // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
        var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
      }
    }

    var ver = iOSversion();
    var OS = getMobileOperatingSystem()


    //check for iOS 7 and down
    if (OS == 'iOS' && ver <= 7) {
        jQuery('body').addClass('ios7');
        //console.log('ios7');
    }

    //Check for Edge 16
    var ua = window.navigator.userAgent;
    if (/Edge\/16.16299/i.test(ua)) {
        jQuery('body').addClass('edge16');
        //console.log("Windows Edge 16");
    }

      //For detacting desktop and remove Use my current location on storelocator page
      if (OS == 'iOS' || OS == 'Android' || OS == 'Windows Phone') {
          jQuery(".sf-widget__button--finder").removeClass("d-none");
          //console.log('Mobile');
      } else {
          //console.log('Not Mobile');
      }

          // if (OS == 'iOS') {
          //     jQuery(".sf-widget__button--finder").css("display", "block");
          //     console.log('Mobile');
          // }

          // else if (OS == 'Android') {
          //     jQuery(".sf-widget__button--finder").css("display", "block");
          //     console.log('Mobile');
          // }

          // else if (OS == 'Windows Phone') {
          //     jQuery(".sf-widget__button--finder").css("display", "block");
          //     console.log('Mobile');
          // }

});

